"use strict";
import React from "react";
import PropTypes from "prop-types";
import FormsyFields from "../formsyFields";
import StyledCheckbox from '../styledCheckbox';

const initComponent = (flex = window.flex, FlexApiRequest = window.FlexApiRequest) => {

    const { countries } = flex;

    class AddEditLocation extends React.Component {
        constructor(props, context) {
            super(props, context);

            this.state = {
                saving: false
            };

            context.formHandler.onSubmit = this._handleSubmit;
        }

        componentDidMount() {
        }

        modelToAddress(model) {
            let {
                saveAddress,
                ...capturedValues
            } = model;

            return Object.assign({
                activation: 'Active',
                auditKey: null,
                county: null,
                isPrimary: false,
                label: this.props.kind,
                latitude: 0.0,
                longitude: 0.0
            }, capturedValues, {
                    kind: this.props.kind
                })
        }

        _handleSubmit = async model => {
            if (this.state.saving) {
                return;
            }
            let address = this.modelToAddress(model);
            console.log(address);
            if (model.saveAddress || (this.props.isEdit && !!address.id)) {
                address = await this.saveAddress(address);
            }

            this.props.onSubmitted(address);
        };

        async saveAddress(address) {
            const path = '/api/v1/org/saveaddress';
            let newAddress = address;

            let response;

            this.setState({ saving: true });
            try {
                response = await FlexApiRequest.POST({ path }).send({ address, orgId: this.props.orgId });
                newAddress = response.data.address;
            } catch (e) {
                console.error(`SaveAdress Exception: ${e}`);
            } finally {
                this.setState({ saving: false });
            }

            return newAddress;
        }

        countries() {
            return [{ label: flex.text('UX_HOME_ACCOUNT_SETTINGS_OPTION_SELECT', '--Select--'), value: '' }].concat(countries.map(country => {
                return {
                    label: country.Name,
                    value: country.Name
                }
            }));
        }

        states() {
            let countryName = this.props.formModel().country;
            const country = countries.find(country => country.Name === countryName);

            if (!country) {
                return;
            }

            return [{ label: flex.text('UX_HOME_ACCOUNT_SETTINGS_OPTION_SELECT', '--Select--'), value: '' }].concat(country.States.map(state => {
                return {
                    label: state.Name,
                    value: state.Abbreviation
                };
            }));
        }

        render() {
            const {
                address,
                isEdit,
                saveAddressCheckboxEnabled
            } = this.props;

            const states = this.states();

            let title = isEdit ? flex.text('UX_HOME_ACCOUNT_SETTINGS_EDIT_LOCATION_LBL', 'Edit Location') : flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_LBL', 'Add a Location');

            return <div>
                <h1>{title}</h1>
                <FormsyFields.Input
                    name="line1"
                    label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_ADDRESS', 'Address')}
                    placeholder={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_STREET_ADDRESS', 'Street Address')}
                    value={address.line1}
                    maxLength="250"
                    type="text"
                    layout="vertical"
                    required={true}
                    validationErrors={{ required: flex.text('UX_HOME_ACCOUNT_SETTINGS_VALIDATE_REQUIRED_ADDRESS', 'Address is a required field') }}
                />
                <FormsyFields.Input
                    name="line2"
                    label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_ADDRESS_SECOND', 'Address 2')}
                    placeholder={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_ADDRESS_SECOND', 'Address 2')}
                    value={address.line2}
                    maxLength="150"
                    type="text"
                    layout="vertical"
                />
                <div className="row">
                    <div className="col-sm-6">
                        <FormsyFields.Input
                            name="city"
                            label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_CITY', 'City')}
                            placeholder={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_CITY', 'City')}
                            value={address.city}
                            maxLength="100"
                            type="text"
                            required={true}
                            validations={{
                                alphaOnly: (values, value) => /^[a-zA-Z ]+$/.test(value)
                            }}
                            validationErrors={{
                                alphaOnly: flex.text('UX_HOME_ACCOUNT_SETTINGS_VALIDATE_CHARACTERS', 'Invalid characters entered')
                            }}
                            layout="vertical"
                        />
                    </div>
                    <div className="col-sm-6">
                        {countries ?
                            <FormsyFields.Select
                                name="country"
                                label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_COUNTRY', 'Country')}
                                value={address.country}
                                options={this.countries()}
                                required={true}
                                layout="vertical"
                                ref="selectedCountry"
                            /> :
                            <FormsyFields.Input
                                name="country"
                                label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_COUNTRY', 'Country')}
                                placeholder={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_TYPE_COUNTRY', 'Type Country')}
                                value={address.country}
                                required={true}
                                layout="vertical"
                            />
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        {states ? <FormsyFields.Select
                            name="stateOrRegion"
                            label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_STATE_REGION', 'State Or Region')}
                            value={address.stateOrRegion}
                            options={states}
                            required={true}
                            layout="vertical"
                        /> :
                            <FormsyFields.Input
                                name="stateOrRegion"
                                label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_STATE_REGION', 'State Or Region')}
                                placeholder={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_SELECT_COUNTRY', 'Select Country')}
                                value=""
                                required={true}
                                layout="vertical"
                                disabled
                                className="disabled"
                                style={{ background: 'lightgray', textAlign: 'center' }}
                            />
                        }
                    </div>
                    <div className="col-sm-6">
                        <FormsyFields.Input
                            name="postalCode"
                            label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_ZIP', 'Zip')}
                            placeholder={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_ZIP', 'Zip')}
                            value={address.postalCode}
                            type="text"
                            required={true}
                            layout="vertical"
                        />
                    </div>
                </div>

                {saveAddressCheckboxEnabled ?
                    <div className={!isEdit ? '' : 'hidden'}>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group col-xs-12">
                                    <div className="checkbox-group">
                                        <StyledCheckbox name="saveAddress"
                                            label={flex.text('UX_HOME_ACCOUNT_SETTINGS_ADD_LOCATION_SAVE', 'Save and Add to my Locations')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <FormsyFields.Input style={{ display: "None" }} id="id" name="saveAddress" value={true} type="checkbox" />
                    </div>
                }

                <FormsyFields.Input style={{ display: "None" }} id="id" name="id" value={address.id} type="text" />
                <FormsyFields.Input style={{ display: "None" }} id="isoCountryCode" name="isoCountryCode" value={address.isoCountryCode} type="text" />
                <FormsyFields.Input style={{ display: "None" }} id="kind" name="kind" value={address.kind} type="text" />
            </div>;
        }
    }

    AddEditLocation.contextTypes = {
        formHandler: PropTypes.object
    };

    AddEditLocation.propTypes = {
        address: PropTypes.shape({
            city: PropTypes.string.isRequired,
            country: PropTypes.string.isRequired,
            county: PropTypes.string,
            id: PropTypes.string.isRequired,
            isoCountryCode: PropTypes.string.isRequired,
            kind: PropTypes.string,
            line1: PropTypes.string.isRequired,
            line2: PropTypes.string,
            postalCode: PropTypes.string.isRequired,
            stateOrRegion: PropTypes.string.isRequired
        }),
        saveAddressCheckboxEnabled: PropTypes.bool,
        isEdit: PropTypes.bool,
        kind: PropTypes.string.isRequired,
        onSubmitted: PropTypes.func.isRequired,
        orgId: PropTypes.string
    };

    AddEditLocation.defaultProps = {
        address: {
            city: '',
            country: '',
            county: '',
            id: '',
            isoCountryCode: '',
            kind: '',
            line1: '',
            line2: '',
            postalCode: '',
            stateOrRegion: ''
        },
        saveAddressCheckboxEnabled: true,
        isEdit: false
    };

    return AddEditLocation;
}

module.exports = initComponent;